'use client';

interface HtmlRendererProps {
  content: string;
}

export default function HtmlRenderer({ content }: HtmlRendererProps) {
  if (!content) return null;

  return (
    <div
      className="prose prose-invert prose-lg max-w-none
        prose-headings:text-white 
        prose-p:text-slate-300 prose-p:leading-relaxed
        prose-a:text-amber-500 prose-a:no-underline hover:prose-a:underline
        prose-strong:text-white 
        prose-code:text-amber-400 prose-code:bg-slate-800 prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:font-mono prose-code:text-sm
        prose-pre:bg-slate-900 prose-pre:border prose-pre:border-slate-800 prose-pre:rounded-lg
        prose-blockquote:border-l-amber-500 prose-blockquote:text-slate-400 prose-blockquote:italic
        prose-li:text-slate-300
        prose-img:rounded-lg
        prose-table:border-slate-700
        prose-th:text-white prose-th:border-slate-700
        prose-td:border-slate-700
        [&_h1]:text-4xl [&_h1]:font-bold [&_h1]:mt-12 [&_h1]:mb-6 [&_h1]:text-white
        [&_h2]:text-3xl [&_h2]:font-bold [&_h2]:mt-10 [&_h2]:mb-4 [&_h2]:text-white
        [&_h3]:text-2xl [&_h3]:font-semibold [&_h3]:mt-8 [&_h3]:mb-3 [&_h3]:text-white
        [&_h4]:text-xl [&_h4]:font-semibold [&_h4]:mt-6 [&_h4]:mb-2 [&_h4]:text-white
        [&_p]:text-slate-300 [&_p]:leading-relaxed [&_p]:mb-4
        [&_a]:text-amber-500 [&_a]:hover:text-amber-400 [&_a]:underline [&_a]:underline-offset-2 [&_a]:transition-colors
        [&_ul]:list-disc [&_ul]:list-inside [&_ul]:space-y-2 [&_ul]:text-slate-300 [&_ul]:my-4 [&_ul]:ml-4
        [&_ol]:list-decimal [&_ol]:list-inside [&_ol]:space-y-2 [&_ol]:text-slate-300 [&_ol]:my-4 [&_ol]:ml-4
        [&_blockquote]:my-6 [&_blockquote]:pl-6 [&_blockquote]:border-l-4 [&_blockquote]:border-amber-500 [&_blockquote]:italic [&_blockquote]:text-slate-400
        [&_pre]:bg-slate-900 [&_pre]:border [&_pre]:border-slate-800 [&_pre]:p-4 [&_pre]:rounded-lg [&_pre]:overflow-x-auto [&_pre]:text-sm
        [&_code]:bg-slate-800 [&_code]:text-amber-400 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-sm [&_code]:font-mono
        [&_table]:min-w-full [&_table]:divide-y [&_table]:divide-slate-700 [&_table]:border [&_table]:border-slate-700 [&_table]:rounded-lg
        [&_thead]:bg-slate-800
        [&_th]:px-4 [&_th]:py-3 [&_th]:text-left [&_th]:text-sm [&_th]:font-semibold [&_th]:text-white [&_th]:border-b [&_th]:border-slate-700
        [&_td]:px-4 [&_td]:py-3 [&_td]:text-sm [&_td]:text-slate-300 [&_td]:border-b [&_td]:border-slate-800
        [&_img]:rounded-lg [&_img]:my-8
        [&_hr]:my-12 [&_hr]:border-0 [&_hr]:h-px [&_hr]:bg-gradient-to-r [&_hr]:from-transparent [&_hr]:via-slate-600 [&_hr]:to-transparent"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}

